import React, { PropsWithChildren, useMemo } from 'react'
import GameInfo from '../lib/models/GameInfo'
import { ROUND_TIMEOUT, ROUND_DELAY } from '../config'
import moment, { Moment } from 'moment'
import buildPlayerGameStatusMutation from '../gql/mutations/buildPlayerGameStatusMutation'
import { useMutation } from '@apollo/client'
import { PlayerInfo } from '../lib/models/PlayerInfo'


const GameContext = React.createContext<GameSessionData>(null!)

export interface GameSessionData {
  id: string,
  dateStart: Moment,
  questionSet : number,
  roundEndTimes: Moment[],
  players: PlayerInfo[]
}

interface GameContextProviderProps {
  game: GameInfo,
  playerId: string,
  totalRounds: number
}



const GameContextProvider = ({ game, totalRounds, children }: PropsWithChildren<GameContextProviderProps>) => {
  const roundLength = ROUND_TIMEOUT + ROUND_DELAY
  const roundEndTimes = []
  for(let i = 1; i <= totalRounds; i++){
    const offset = roundLength * i
    const end = moment(game.dateStart).add(offset, "s")
    roundEndTimes.push(end)
  }
  
  const data = {
    id: game.id,
    dateStart: game.dateStart,
    questionSet: game.questionSet,
    roundEndTimes,
    players: game.players
   }


  return (
    <GameContext.Provider value={data}>
      {children}
    </GameContext.Provider>
  )
}

export { GameContext, GameContextProvider }
